export const getColorStatus = (companyCountType: number) => companyCountType >= 0